(function(window, angular, undefined) {
    var app = angular.module('formApp');
    app.directive("textReplace", ['$filter', function($filter) {
        return {
            restrict: "A",
            link: function($scope, element, attrs, ctrl) {
                var textReplaceFilter = $filter('textReplace'),
                    replacementText = attrs.textReplace;
                element.html(textReplaceFilter( element.html(), replacementText));                                                                                                            
            }
        };
    }]);
})(window, window.angular);